import { ModalStackState } from 'src/modules/modals/types/ModalStackState';
import { RootState } from 'src/types/RootState';

export function getModalStack(state: RootState): ModalStackState {
  return state.modals;
}
